import { FC } from "react";
import { IMessage } from "../../../../common/api_interfaces/chat/IMessage";

const MessageActions: FC<{
    message: IMessage;
    onEdit: (message: IMessage) => void;
    onDelete: (id: number) => void;
    canDelete: boolean;
    showToast: (message: string) => void;
}> = ({ message, onEdit, onDelete, canDelete, showToast }) => (
    <div className="input--chat__block--messages__message--buttons">
        {!message.readOnly && (
            <button onClick={() => onEdit(message)}>
                Редактировать
            </button>
        )}
        
        <button onClick={() => 
            canDelete 
                ? onDelete(message.id) 
                : showToast("У вас нет прав на удаление!")
        }>
            Удалить
        </button>
    </div>
);

export default MessageActions;